import { useMutation } from "@apollo/client";
import { CREATE_FINANCE_TREE_TRANSACTION } from "../graphql/mutations/financeTransaction.graphql";

interface TransactionLineInput {
  financeTreeId: number;
  description?: string;
  debit?: number;
  credit?: number;
}

interface MediaInput {
  fileName: string;
  originalName: string;
  mimeType: string;
  size: number;
  type: string;
  url: string;
  isActive?: boolean;
  altText?: string;
  description?: string;
}

interface CreateFinanceTreeTransactionDto {
  date: string;
  description: string;
  media?: MediaInput | null; // Single object, not array
  transactionLines: TransactionLineInput[];
}

interface CreateFinanceTreeTransactionVariables {
  createFinanceTreeTransactionDto: CreateFinanceTreeTransactionDto;
}

interface FinanceTreeTransaction {
  id: number;
  transactionNumber: string;
  date: string;
  description?: string;
  imageId?: number | null;
  totalDebit: number;
  totalCredit: number;
  isBalanced: boolean;
  createdAt: string;
  updatedAt: string;
}

interface CreateFinanceTreeTransactionData {
  createFinanceTreeTransaction: FinanceTreeTransaction;
}

export const useCreateFinanceTransaction = () => {
  return useMutation<CreateFinanceTreeTransactionData, CreateFinanceTreeTransactionVariables>(
    CREATE_FINANCE_TREE_TRANSACTION
  );
};

